<template>
  <div class="animated fadeIn">
    <div class="block-screen" v-if="loading"><i class="fa fa-refresh fa-spin"></i></div>
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0"> {{ data.totalUsers }}
              <span class="pull-right" style="font-size: 19px;">
                <i class="fa fa-user"></i>
              </span>
            </h4>
            <br>
            <h6>Participantes cadastrados no sistema</h6>
          </b-card-body>
          <div class="chart-wrapper px-3" style="height:10px;"></div>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0"> {{ data.pendingUsers }}
              <span class="pull-right" style="font-size: 19px;">
                <i class="fa fa-user"></i>
              </span>
            </h4>
            <br>
            <h6>Participantes não cadastrados no sistema</h6>
          </b-card-body>
          <div class="chart-wrapper px-3" style="height:10px;"></div>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0"> {{ data.guests }}
              <span class="pull-right" style="font-size: 19px;">
                <i class="fa fa-users"></i>
              </span>
            </h4>
            <br>
            <h6>Acompanhantes cadastrados no sistema</h6>
          </b-card-body>
          <div class="chart-wrapper px-3" style="height:10px;"></div>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0"> {{ data.completedFlight }}
              <span class="pull-right" style="font-size: 19px;">
                <i class="fa fa-plane"></i>
              </span>
            </h4>
            <br>
            <h6>Participantes com seleção de voo concluída.</h6>
          </b-card-body>
          <div class="chart-wrapper px-3" style="height:10px;"></div>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0"> {{ data.completedGuests }}
              <span class="pull-right" style="font-size: 19px;">
                <i class="fa fa-plane"></i>
              </span>
            </h4>
            <br>
            <h6>Acompanhantes com voo selecionado.</h6>
          </b-card-body>
          <div class="chart-wrapper px-3" style="height:10px;"></div>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0"> {{ data.extraGuests }}
              <span class="pull-right" style="font-size: 19px;">
                <i class="fa fa-plane"></i>
              </span>
            </h4>
            <br>
            <h6>Acompanhantes extras.</h6>
          </b-card-body>
          <div class="chart-wrapper px-3" style="height:10px;"></div>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3" v-for="flight in data.countFlights.flights" v-bind:key="flight.id"
        v-if="flight.company">
        <b-card no-body :class="{'bg-light': flight.available > 10, 'bg-secondary': flight.available <= 10}">
          <b-card-body class="pb-0">
            <h6 class="mb-0"> Grupo {{ flight.group_number }}
              <!-- <span style="font-size: 10px;">- {{ flight.departure_flight }} | {{ flight.return_flight }}
                - {{ flight.departure_date? flight.departure_date.substr(6, 7): '---' }}
              </span> -->
              <span class="pull-right" style="font-size: 19px;">
                <i class="fa fa-plane"></i>
              </span>
            </h6>
            <br>
            <h6>
              Vagas disponíveis: {{ flight.available }} <br>
              Total de vagas: {{ flight.available_places }}
            </h6>
          </b-card-body>
          <div class="chart-wrapper px-3" style="height:19px;"></div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    name: 'dashboard',
    data () {
      return {
        data: {
          totalUsers: 0,
          guests: 0,
          pendingFlight: 0,
          pendingUsers: 0,
          completedFlight: 0,
          completedUsers: 0,
          completedGuests: 0,
          extraGuests: 0,
          countFlights: {
            flights: []
          }
        },
        loading: false
      }
    },
    mounted () {
      this.loading = true
      this.$http.get(`dashboard`)
        .then(response => {
          this.data = response.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
</script>

<style>
  .bg-secondary {
    background-color: #F03434 !important;
    border-color: #d80f0f !important;
    color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue